import { first, values } from 'lodash';

const THEME_DEFAULT = 'base';
const THEME_TEST = 'test';
const THEME_DARK_BLUE = 'dark-blue';
const THEME_PURPLE = 'purple';
const THEME_IMPROVEMENT_HUB = 'improvement-hub';
const THEME_INSPECTION_COACH = 'inspection-coach';
const THEME_TO_BUILD_A_PROFILE = 'evidence-me';
const THEME_TO_BUILD_A_PROFILE_PARTIAL = 'evidence-partial';
const THEME_TO_BUILD_A_PROFILE_REPORTS = 'evidence-reports';
const THEME_TO_BUILD_A_PROFILE_PROFILES = 'evidence-profiles';
const THEME_TO_BUILD_A_PROFILE_LEARNERS = 'evidence-learners';
const THEME_KUTUBEE_DEFAULT = 'kutubee-base';
const THEME_KUTUBEE_ADMIN = 'kutubee-admin';
const THEME_KUTUBEE_RA = 'kutubee-ra';

export class ThemeService {

  static themePrefix = 'theme-';

  static LAYOUT_DIRECTION = {
    LEFT_TO_RIGHT: 'ltr',
    RIGHT_TO_LEFT: 'rtl'
  };

  get layoutDirection() {
    if (this.rootElement) {
      return this.rootElement.getAttribute('dir');
    }

    return ThemeService.LAYOUT_DIRECTION.LEFT_TO_RIGHT;
  }

  get rootElement() {
    return first(window.document.getElementsByTagName('html'));
  }

  get currentTheme() {
    if (!this.rootElement) {
      return '';
    }

    const themeClassName = this.rootElement.className;
    const theme = themeClassName.replace(ThemeService.themePrefix, '');
    return values(this.THEMES).includes(theme) ? theme : '';
  }

  set rtl(val) {
    const html = this.rootElement;
    if (val) {
      html.setAttribute('dir', ThemeService.LAYOUT_DIRECTION.RIGHT_TO_LEFT);
    } else {
      html.setAttribute('dir', ThemeService.LAYOUT_DIRECTION.LEFT_TO_RIGHT);
    }
  }

  THEMES = {
    THEME_DEFAULT,
    THEME_TEST,
    THEME_DARK_BLUE,
    THEME_PURPLE,
    THEME_IMPROVEMENT_HUB,
    THEME_INSPECTION_COACH,
    THEME_TO_BUILD_A_PROFILE,
    THEME_TO_BUILD_A_PROFILE_PARTIAL,
    THEME_TO_BUILD_A_PROFILE_REPORTS,
    THEME_TO_BUILD_A_PROFILE_PROFILES,
    THEME_KUTUBEE_DEFAULT,
    THEME_KUTUBEE_ADMIN,
    THEME_KUTUBEE_RA,
    THEME_TO_BUILD_A_PROFILE_LEARNERS
  };

  includeTheme(theme = THEME_DEFAULT) {
    return this.injectTheme(theme);
  }

  injectTheme(theme = THEME_DEFAULT) {
    const html = this.rootElement;
    if (html) {
      html.className = `${ThemeService.themePrefix}${theme}`;
      return true;
    }

    return false;
  }

  removeThemes() {
    this.rootElement.className = '';
  }

}

export const themeService = new ThemeService();
